export default __webpack_public_path__ + "static/media/asado.08093459.jpg";